<template>
  <v-select
    :rules="[v => !required || !!v || 'Please select a task type']"
    :items="taskTypesList"
    @change="onChangeTaskType"
    v-model="model"
    :item-value="itemValue"
    label="Task Type" solo>
    <template slot="item" slot-scope="{ item }">
      <template v-if="item && item.hasOwnProperty('name')">
        <span :data-test-dropdown-option="`${$attrs['data-test']}-${item.id}`">
          {{ item.name }}
        </span>
      </template>
    </template>
    <template slot="selection" slot-scope="{ item }">
      <template v-if="item && item.hasOwnProperty('name')">
        {{ item.name }}
      </template>
    </template>
  </v-select>
</template>

<script>
import ModelBinding from '@/mixins/ModelBinding'

export default {
  name: 'TaskTypesSelect',
  mixins: [ ModelBinding ],
  props: {
    required: {
      type: Boolean,
      default: false
    },
    itemValue: {
      type: String,
      default: 'idx'
    }
  },
  data () {
    return {
      taskTypes: Object.values(this.$store.state.tasks.taskTypes)
    }
  },
  computed: {
    taskTypesList () {
      return this.taskTypes.map((taskType, idx) => ({ idx, ...taskType })).filter(type => type.expires_at === null)
    }
  },
  methods: {
    onChangeTaskType (taskType) {
      this.$emit('change', this.taskTypes[taskType])
    }
  }
}
</script>
